// extracted by mini-css-extract-plugin
export var collapsedSummary = "_nw-0";